import { LayoutAlign, LayoutFlexDirection, LayoutJustify } from '@philips-internal/oswald-ui-constants';
import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
class PanelAPI extends ComponentAPI {
    /**
     * Gets the align items property.
     *
     * @returns the align items property.
     */
    getAlignItems() {
        return this.state.alignItems;
    }
    /**
     * Sets the align items property of the Panel.
     *
     * @param alignItems - The align items value.
     */
    setAlignItems(alignItems) {
        if (isEnumValid(LayoutJustify, LayoutAlign)) {
            this.setState({ alignItems });
        }
    }
    /**
     * Gets the background property.
     *
     * @returns the background property.
     */
    getBackground() {
        return this.state.background;
    }
    /**
     * Sets the background property of the Panel.
     *
     * @param background - The background value.
     */
    setBackground(background) {
        this.setState({ background });
    }
    /**
     * Gets the border property.
     *
     * @returns the border property.
     */
    getBorder() {
        return this.state.border;
    }
    /**
     * Sets the border property of the Panel.
     *
     * @param border - The border value.
     */
    setBorder(border) {
        this.setState({ border });
    }
    /**
     * Gets the border radius property.
     *
     * @returns the border radius property.
     */
    getBorderRadius() {
        return this.state.borderRadius;
    }
    /**
     * Sets the border radius property of the Panel.
     *
     * @param borderRadius - The border radius value.
     */
    setBorderRadius(borderRadius) {
        this.setState({ borderRadius });
    }
    /**
     * Gets the box shadow property.
     *
     * @returns the box shadow property.
     */
    getBoxShadow() {
        return this.state.boxShadow;
    }
    /**
     * Sets the box shadow property of the Panel.
     *
     * @param boxShadow - The box shadow value.
     */
    setBoxShadow(boxShadow) {
        this.setState({ boxShadow });
    }
    /**
     * Gets the height property.
     *
     * @returns the height property.
     */
    getHeight() {
        return this.state.height;
    }
    /**
     * Sets the height property of the Panel.
     *
     * @param height - The height value.
     */
    setHeight(height) {
        this.setState({ height });
    }
    /**
     * Gets the justify content property.
     *
     * @returns the justify content property.
     */
    getJustifyContent() {
        return this.state.justifyContent;
    }
    /**
     * Sets the justify content property of the Panel.
     *
     * @param justifyContent - The justify content value.
     */
    setJustifyContent(justifyContent) {
        if (isEnumValid(LayoutJustify, justifyContent)) {
            this.setState({ justifyContent });
        }
    }
    /**
     * Gets the light theme property.
     *
     * @returns a boolean indicating if it is using the light theme.
     */
    isLightTheme() {
        return this.state.lightTheme;
    }
    /**
     * Sets the light theme property of the Panel.
     *
     * @param lightTheme - Defines if the Panel will use the light theme.
     */
    setLightTheme(lightTheme) {
        this.setState({ lightTheme });
    }
    /**
     * Gets the margin property.
     *
     * @returns the margin property.
     */
    getMargin() {
        return this.state.margin;
    }
    /**
     * Sets the margin property of the Panel.
     *
     * @param margin - The margin value.
     */
    setMargin(margin) {
        this.setState({ margin });
    }
    /**
     * Gets the padding property.
     *
     * @returns the padding property.
     */
    getPadding() {
        return this.state.padding;
    }
    /**
     * Sets the padding property of the Panel.
     *
     * @param padding - The padding value.
     */
    setPadding(padding) {
        this.setState({ padding });
    }
    /**
     * Gets the visible property.
     *
     * @returns a boolean indicating if the panel is visible
     */
    isVisible() {
        return this.state.visible;
    }
    /**
     * Sets the visible property of the Panel.
     *
     * @param visible - The visible value.
     */
    setVisible(visible) {
        this.setState({ visible });
    }
    /**
     * Gets the flex direction property.
     *
     * @returns the flex direction property.
     */
    getFlexDirection() {
        return this.state.flexDirection;
    }
    /**
     * Sets the flex direction property of the Panel.
     *
     * @param flexDirection - The flex direction value.
     */
    setFlexDirection(flexDirection) {
        if (isEnumValid(LayoutFlexDirection, flexDirection)) {
            this.setState({ flexDirection });
        }
    }
    /**
     * Gets the gap between items contained by the component.
     */
    getGap() {
        return this.state.gap;
    }
    /**
     * Sets the gap between items contained of the component.
     *
     * @param gap - The gap between items.
     */
    setGap(gap) {
        this.setState({ gap });
    }
}
export { PanelAPI, };
export default PanelAPI;
//# sourceMappingURL=panel-api.js.map